import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=78417138&scoped=true&"
import script from "./GroupCreate.vue?vue&type=script&lang=ts&"
export * from "./GroupCreate.vue?vue&type=script&lang=ts&"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=78417138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78417138",
  null
  
)

export default component.exports